module.exports = __webpack_public_path__ + "static/media/whatsapp.f2068db6.svg";